import axios from 'axios';
import { attachInvestigateToken } from './investigateAuth';
export const serverIp = 'https://api.connect.scalens.com';

const httpClientPublic = axios.create({
  baseURL: `${serverIp}/public`,
  withCredentials: true,
});

const httpClientPublicCustomer = axios.create({
  baseURL: `${serverIp}/public`,
  withCredentials: true,
});

const httpClientCustomer = axios.create({
  baseURL: serverIp,
  withCredentials: true,
});

const httpClientGlobal = axios.create({
  baseURL: serverIp,
  withCredentials: true,
});

// app-api (Investigate): the only client for REACT_APP_API_URL. Every request carries a fresh
// Auth0 access token, see investigateAuth.js.
const httpClientInvestigate = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: false,
});
httpClientInvestigate.interceptors.request.use(attachInvestigateToken);

export {
  httpClientGlobal,
  httpClientCustomer,
  httpClientPublic,
  httpClientPublicCustomer,
  httpClientInvestigate,
};
